import React from "react";
import SvgIcon from "e100-react-components/lib/components/SvgIcon";
import { IProps } from "e100-react-components/lib/components/SvgIcon/index";

export const Share = (props: IProps) => (
  <SvgIcon {...props}>
    <path d="M16 4L14.58 5.42L12.99 3.83V15H11.01V3.83L9.42 5.42L8 4L12 0L16 4ZM20 9V20C20 21.1 19.1 22 18 22H6C4.89 22 4 21.1 4 20V9C4 7.89 4.89 7 6 7H9V9H6V20H18V9H15V7H18C19.1 7 20 7.89 20 9Z"/>
  </SvgIcon>
);
